import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import { Fragment, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useImmer } from "use-immer";
import {
  Autocomplete,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { ADD_USER, APP_BASE_URL, GET_USER_ROLES, MCDO_EMPLOYEE_BIODATA, UPDATE_USER } from "../../Common/EndPoints";
import axios from "axios";
import { Transition } from "../../Modal/ModalConstants";
import { toast } from "react-hot-toast";
import { extractAllowedUserRoleList } from "../../Utils/Utils";
import { debounce } from "@mui/material/utils";
import axiosInstancePcdo from "../PCDO/pcdoAxiosInstance";
import { event } from "jquery";
import { getParsedLocalStorage } from "../../Utils/storage-utils";
import { AutocompleteStationListPop } from "../AutocompleteStationListPop/AutocompleteStationListPop";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  authority: "",
  delegateRole: "",
  zoneCode: [],
  mobileNumber: "",
  zoneList: [],
  divisionCode: [],
  divisionList: [],
  stationCode: [],
  stationList: [],
  userRoleList: [],
  userDelegateRoleList: [],
  divisionStationList: {},
  firstNameError: false,
  confirmPasswordError: false,
  confirmPassword: "",
  lastNameError: false,
  firstNameErrorText: "",
  lastNameErrorText: "",
  emailError: false,
  passwordError: false,
  zoneCodeError: false,
  divisionCodeError: false,
  mobileNumberError: false,
  stationCodeError: false,
  authorityError: false,
};
const intitialSnackbarState = {
  open: true,
  severityType: "",
  snackbarMessage: "",
};
const AddUser = ({ open, onClose, label, editRow, update, userStationsData, users, loggedInUserPcdoData }) => {
  const system_options = useMemo(() => {
    const systems = getParsedLocalStorage("systems_list", []);
    return systems.map((system) => ({
      id: system.id,
      label: system.code,
    }));
  }, []);
  const [state, setState] = useImmer(initialState);
  const [pcdoUserdata, setPcdoUserData] = useState(null);
  const [pcdoUserFormValidation, setPcdoUserFormValidation] = useImmer({});
  // console.log("pcdoUserFormValidation", pcdoUserFormValidation);
  const [pcdoUserForm, setPcdoUserForm] = useImmer({});
  const [pcdoUserRoleOptions, setPcdoUserRoleOptions] = useState([]);
  const [pcdoUserGroupesOptions, setPcdoUserGroupesOptions] = useState([]);
  // console.log("pcdoUserForm", pcdoUserForm);
  // console.log("options", pcdoUserGroupesOptions, pcdoUserRoleOptions);
  const [value, setValue] = useState("");
  const [snackBarState, setSnackBarState] = useImmer(intitialSnackbarState);
  const [userOptions, setUserOptions] = useState([]);
  const searchEmailRef = useRef();
  function handleInputChange(event) {
    const newValue = event.target.value.replace(/[^\d]/g, "");

    // const newValue = event.target.value.replace(/[^0-9.]/g, "");
    // const parts = newValue.split(".");
    // if (parts.length > 2) {
    //   parts.pop();
    //   newValue = parts.join(".");
    // }
    if (newValue.length <= 10) {
      setState((prev) => {
        prev.mobileNumber = newValue;
      });
    }
  }

  useEffect(() => {
    getUserRoles();
  }, [state.serviceType]);

  useEffect(() => {
    getZone();
    // getUserRoles();
  }, []);

  useEffect(() => {
    if (!pcdoUserForm.isPcdoUser) {
      setPcdoUserForm({ isPcdoUser: pcdoUserForm.isPcdoUser });
    }
  }, [pcdoUserForm.isPcdoUser]);
  useLayoutEffect(() => {
    if (editRow) {
      let zone = Object.keys(editRow.permissions).toString();
      fetchPcdoUser(editRow?.id);

      setState((previousState) => {
        previousState.firstName = editRow.firstName;
        previousState.lastName = editRow.lastName;
        previousState.email = editRow.email;
        previousState.zoneCode = editRow.zones;
        previousState.authority = editRow?.authority;
        previousState.mobileNumber = editRow?.mobileNumber;
        previousState.systems = editRow?.softwareResponses?.map((system) => ({ id: system.id, label: system.code }));
        previousState.serviceType = editRow?.["G/NG"] || "";
        previousState.password = "";
      });
    }
    getPcdoUserRole();
    getPcdoUserGroup();
  }, []);
  const _userGroupsOptions = useMemo(() => {
    let _list = [];
    if (pcdoUserForm?.role_id && pcdoUserGroupesOptions.length) {
      const selectedUserRole = pcdoUserRoleOptions.find((obj) => obj.id === pcdoUserForm?.role_id);

      if (selectedUserRole) {
        _list = pcdoUserGroupesOptions.filter((obj) => {
          return obj?.entity?.includes(selectedUserRole?.label?.split("_")?.[0]);
        });
      }
    }
    return _list;
  }, [pcdoUserForm.role_id]);
  const deriveUserGroupOptions = () => {
    let _list = [];
    if (pcdoUserForm?.role_id && pcdoUserGroupesOptions.length) {
      const selectedUserRole = pcdoUserRoleOptions.find((obj) => obj.id === pcdoUserForm?.role_id);

      if (selectedUserRole) {
        _list = pcdoUserGroupesOptions.filter((obj) => {
          return obj?.entity?.includes(selectedUserRole?.label?.split("_")?.[0]);
        });
      }
    }
    return _list;
  };

  const fetchPcdoUser = async (user_id) => {
    let body = {
      app_user_id: user_id,
    };
    try {
      const userRes = await axiosInstancePcdo.post("user/login", body);
      if (userRes.data) {
        const pcdoUserRes = userRes.data;
        setPcdoUserData(pcdoUserRes);
        setPcdoUserForm((prev) => {
          prev.isPcdoUser = true;
          prev.role_id = pcdoUserRes.role_id;
          prev.group_id = pcdoUserRes.group_id;
        });
      }
    } catch (err) { }
  };
  const getPcdoUserRole = async (pcdo_user_id) => {
    try {
      const params = {
        name: "pcdo_user_role",
      };
      const userRoleRes = await axiosInstancePcdo("/generic/table/open", {
        params,
        headers: {
          user_id: pcdo_user_id,
        },
      });
      if (userRoleRes.data) {
        setPcdoUserRoleOptions(
          userRoleRes.data?.map((obj) => {
            return { id: obj.id, label: obj.role };
          }),
        );
      }
    } catch (err) { }
  };
  const getPcdoUserGroup = async (pcdo_user_id) => {
    try {
      const params = {
        name: "group",
      };
      const userGroupsRes = await axiosInstancePcdo("/generic/table/open", {
        params,
        headers: {
          user_id: pcdo_user_id,
        },
      });
      if (userGroupsRes.data) {
        setPcdoUserGroupesOptions(userGroupsRes?.data ?? {});
      }
    } catch (err) { }
  };
  const getZone = () => {
    let zones = [];
    userStationsData?.forEach((zone) => {
      zones = [...zones, ...Object.keys(zone)];
    });

    setState((previousState) => {
      previousState.zoneList = zones;
      // previousState.zoneCode = zones.length > 0 ? zones : [];
    });
  };

  useEffect(() => {
    handleEmailChange("");
  }, [users]);

  useEffect(() => {
    if (state.zoneCode?.length > 0) {
      let divisionList = [];
      userStationsData?.forEach((zones) => {
        if (zones[state.zoneCode]) {
          zones[state.zoneCode].forEach((divisions) => {
            divisionList = [...divisionList, ...Object.keys(divisions)];
          });
        }
      });
      setState((previousState) => {
        previousState.divisionList = divisionList;
        // if (divisionList.length === 1) {
        //   previousState.divisionCode = divisionList;
        // }
        previousState.stationList = [];
      });
      if (editRow && editRow.permissions[state.zoneCode]) {
        let divisions = editRow.permissions[state.zoneCode].map((div) => {
          return Object.keys(div).toString();
        });
        setState((previousState) => {
          previousState.divisionCode = divisions;
        });
      }
    } else {
      setState((previousState) => {
        previousState.divisionList = [];
        previousState.divisionCode = [];
        previousState.stationList = [];
      });
    }
  }, [state.zoneCode]);
  useEffect(() => {
    if (state.divisionCode.length > 0) {
      let stationList = [];
      state.divisionCode.forEach((div) => {
        userStationsData?.forEach((zones) => {
          if (zones[state.zoneCode]) {
            zones[state.zoneCode].forEach((divisions) => {
              if (divisions[div]) {
                divisions[div].forEach((stations) => {
                  stationList = [...stationList, stations.customerName];
                });
              }
            });
          }
        });
      });

      setState((previousState) => {
        previousState.stationList = stationList;
      });
      if (editRow) {
        setState((previousState) => {
          previousState.stationCode = editRow.stations;
          // previousState.stationCode = editRow.stations.split(",");
        });
      }
    } else {
      setState((previousState) => {
        previousState.stationList = [];
      });
    }
  }, [state.divisionCode]);
  const validateForm = () => {
    let isValid = true;
    if (
      !state.firstName ||
      state.firstName.length > 30 ||
      !state.lastName ||
      state.lastName.length > 30 ||
      !state.email ||
      (!editRow && !state.password && !state.confirmPassword) ||
      !state.zoneCode ||
      !state.divisionCode ||
      !state.mobileNumber ||
      state.mobileNumber.length < 10 ||
      !state.stationCode ||
      !state.systems ||
      state.systems.length === 0
    ) {
      isValid = false;
    }

    let confirmPasswordErrorText = "";
    let systemsErrorText = "";
    if (!editRow) {
      if (!state.confirmPassword) {
        isValid = false;
        confirmPasswordErrorText = "Please enter a password for confirmation";
      }
      if (state.confirmPassword && state.confirmPassword !== state.password) {
        isValid = false;
        confirmPasswordErrorText = "Password did not match";
      }
    }
    if (!state.systems || state.systems.length === 0) {
      isValid = false;
      systemsErrorText = "Please select at least one system";
    }

    function get_error_message(word, length_check = false) {
      if (!word) return "Field is required";

      function is_length_under_56() {
        if (word.length > 56) return "Must be under 56 characters";
        return null;
      }

      if (length_check) return is_length_under_56();
      return null;
    }

    setState((previousState) => {
      previousState.firstNameError = !state.firstName || state.firstName.length > 56;
      previousState.firstNameErrorText = get_error_message(state.firstName, true);
      previousState.lastNameError = !state.lastName || state.lastName.length > 56;
      previousState.lastNameErrorText = get_error_message(state.lastName, true);
      previousState.emailError = !state.email;
      previousState.systemsErrorText = systemsErrorText;
      if (!editRow) previousState.passwordError = !state.password;
      previousState.zoneCodeError = !state.zoneCode;
      previousState.confirmPasswordError = confirmPasswordErrorText;
      previousState.divisionCodeError = !state.divisionCode[0];
      previousState.stationCodeError = !state.stationCode[0];
      previousState.customerIdError = !state.customerId;
      previousState.mobileNumberError = state.mobileNumber.length < 10;
    });

    if (!isValid) {
      toast.error("Please fill all the mandatory fields");
    }
    return isValid;
  };

  // const getUserRoles = () => {
  //   let url = `${APP_BASE_URL}${GET_USER_ROLES}`;
  //   axios.get(url).then((res) => {
  //     let RESPONSE = res.data.data;
  //     let roleList = Object.values(RESPONSE);
  //     console.log(roleList)
  //     setState((prev) => {
  //       prev.userRoleList = roleList;
  //     });
  //   });
  // };

  const getUserRoles = () => {
    let roleHierarchies = JSON.parse(localStorage.getItem("roleHierarchies"));
    let allowedRoleIdList = extractAllowedUserRoleList(roleHierarchies);
    allowedRoleIdList = allowedRoleIdList.filter((role) => {
      if (state.serviceType === "Gazetted") {
        return role?.gazzettedOrNotGazzetted === "Gazetted";
      } else if (state.serviceType === "Non-Gazetted") {
        return role?.gazzettedOrNotGazzetted === "Non-Gazetted";
      }
      return false;
    });
    setState((prev) => {
      prev.userRoleList = allowedRoleIdList.map((role) => role.value);
      prev.userDelegateRoleList = ["NA", "Maintainer"];
    });
  };
  const validatePcdoForm = () => {
    let isValid = true;
    const { isPcdoUser, ...rest } = pcdoUserForm;
    if (isPcdoUser) {
      if (!pcdoUserForm.role_id || !pcdoUserForm.group_id) {
        isValid = false;
      }
      // console.log("pcdoUserFormfgjkljdhgklj", pcdoUserForm);
      setPcdoUserFormValidation((prev) => {
        prev["role_id"] = pcdoUserForm.role_id ? "" : "Role is required";
        prev["group_id"] = pcdoUserForm.group_id ? "" : "Group is required";
      });
    }
    return isValid;
  };
  const onSubmit = async () => {
    const isUserFormValidated = validateForm();
    const isPcdpFormValidated = validatePcdoForm();
    if (isUserFormValidated && isPcdpFormValidated) {
      const payload = {
        authority: state.authority,
        email: state.email,
        firstName: state.firstName,
        lastName: state.lastName,
        password: state.password,
        mobileNumber: state.mobileNumber,
        zoneCode: state.zoneCode.toString(),
        divisionCode: state.divisionCode.toString(),
        stationCode: state.stationCode.toString(),
        softwareIds: state.systems.map((system) => system.id).toString(),
      };
      let successType = " User has been created";
      let apiMethod = axios.post;
      let url = `${APP_BASE_URL}${ADD_USER}?email=${payload.email}&First Name=${payload.firstName}&mobileNo=${payload.mobileNumber}&last Name=${payload.lastName}&password=${payload.password}&zone Code=${payload.zoneCode}&division Code=${payload.divisionCode}&stn Code=${payload.stationCode}&authority=${payload.authority}&softwareIds=${payload.softwareIds}`;
      if (editRow) {
        apiMethod = axios.put;
        successType = "User has been updated";
        url = `${APP_BASE_URL}${UPDATE_USER}/${editRow.id}?email=${payload.email}&mobileNo=${payload.mobileNumber}&authority=${payload.authority}&first name=${payload.firstName}&last name=${payload.lastName}&stn code=${payload.stationCode}&division code=${payload.divisionCode}&zone code=${payload.zoneCode}&softwareIds=${payload.softwareIds}`;
      }

      try {
        const res = await apiMethod(url);

        const userId = !editRow ? res?.data?.data?.userId : editRow.id;
        if (userId) {
          pcdoUserSubmit(pcdoUserdata?.id, userId);
        }

        setState(initialState);
        onClose(true);
        update(successType, "success");
      } catch (err) {
        const errMsg = err?.response?.data?.error?.message.slice(0, 15);
        update(errMsg, "error");
        onClose(true);
      }

      return;
    }

    // console.error("FORM_VALIDATION_ERROR");
  };
  // const pcdoUserSubmit = (pcdo_user_id, edge_user_id) => {
  //   if (pcdo_user_id || pcdoUserForm.isPcdoUser) {
  //     let url = "/user";
  //     const pcdoReqHeader = {
  //       app_user_id: loggedInUserPcdoData?.id,
  //     };
  //     let pcdoAPiReq = axiosInstancePcdo.post;
  //     let pcdoPayload = { app_user_id: edge_user_id, role_id: pcdoUserForm.role_id, group_id: pcdoUserForm.group_id };
  //     if (pcdo_user_id) {
  //       pcdoAPiReq = axiosInstancePcdo.patch;
  //       url = `${url}/${pcdo_user_id}`;
  //       if (!pcdoUserForm.isPcdoUser) {
  //         pcdoAPiReq = axiosInstancePcdo.delete;
  //         pcdoPayload = null;
  //       }
  //     }
  //     try {
  //       const pcdoUserRes = pcdoAPiReq(url, pcdoPayload, { headers: pcdoReqHeader });
  //     } catch (err) {}
  //   }
  // };

  const pcdoUserSubmit = async (pcdo_user_id, edge_user_id) => {
    if (pcdo_user_id || pcdoUserForm.isPcdoUser) {
      let url = "/user";
      const pcdoReqHeader = {
        user_id: loggedInUserPcdoData?.id,
      };

      let pcdoApiReq = axiosInstancePcdo.post;
      let pcdoPayload = {
        app_user_id: edge_user_id,
        role_id: pcdoUserForm.role_id,
        group_id: pcdoUserForm.group_id,
      };

      if (pcdo_user_id) {
        url = `${url}/${pcdo_user_id}`;
        pcdoApiReq = axiosInstancePcdo.patch;

        if (!pcdoUserForm.isPcdoUser) {
          pcdoApiReq = axiosInstancePcdo.delete;
          pcdoPayload = null; // Explicitly setting payload to null for DELETE requests
        }
      }
      // console.log("adjajkfhs", pcdoApiReq, url, pcdoPayload, pcdoReqHeader);
      try {
        // Conditionally send payload only if it exists
        const pcdoUserRes = pcdoPayload
          ? await pcdoApiReq(url, pcdoPayload, { headers: pcdoReqHeader })
          : await pcdoApiReq(url, { headers: pcdoReqHeader });

        return pcdoUserRes;
      } catch (err) {
        // console.error("Error in pcdoUserSubmit:", err);
      }
    }
  };
  const onClear = () => {
    setState(initialState);
    getZone();
  };

  const handleEmailChange = async (value) => {
    clearTimeout(searchEmailRef.current);

    searchEmailRef.current = setTimeout(async () => {
      const fetchedOptions = await getEmployeeBiodata(value);
      setUserOptions(fetchedOptions);
    }, 500);
  };

  const getEmployeeBiodata = async (email) => {
    try {
      const params = {
        email: email || "",
        withoutCreatedUser: true
      }
      let url = `${APP_BASE_URL}${MCDO_EMPLOYEE_BIODATA}`;
      const res = await axios.get(url, { params });
      return res?.data?.data?.content || [];
    } catch (error) {
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong! Try again later!");
        return [];
      }

      toast.error(error?.message || "Something went wrong! Try again later!");
      return [];
    }
  };

  const handlePcdoFormChange = (key, value) => {
    setPcdoUserForm((prev) => {
      prev[key] = value;
    });
  };

  const getSystems = useCallback(() => {
    if (state.systems?.length === system_options.length) {
      // return all options with unselect all option
      return [{ label: "Unselect All", id: "unselect-all" }, ...system_options];
    }
    else {
      // return select all options
      return [{ label: "Select All", id: "select-all" }, ...system_options];
    }
  }, [state.systems])

  return (
    <div>
      <Dialog open={open} onClose={onClose} aria-labelledby="responsive-dialog-title" TransitionComponent={Transition}>
        <DialogTitle id="responsive-dialog-title" className="flex">
          {label}
          <CloseIcon
            className="pointer"
            sx={{ ml: "auto" }}
            onClick={() => {
              onClose(false);
            }}
          />
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              {/* <TextField
                size="small"
                sx={{ minWidth: 250, maxWidth: 250 }}
                onChange={(e) => {
                  setState((draft) => {
                    draft.email = e.target.value;
                  });
                }}
                inputProps={{
                  type: "email",
                }}
                disabled={Boolean(editRow)}
                required
                error={state.emailError}
                type={"mail"}
                value={state.email}
                label={"Email"}
              /> */}

              <Autocomplete
                size="small"
                sx={{ minWidth: 250, maxWidth: 250 }}
                getOptionLabel={(option) => (typeof option === "string" ? option : option?.emailId || "")}
                filterOptions={(x) => x}
                options={userOptions?.map((option) => option?.emailId)}
                autoComplete
                disabled={editRow}
                includeInputInList
                filterSelectedOptions
                value={state.email}
                noOptionsText="No User"
                onChange={(event, newValue) => {
                  let selectedUser = userOptions.find((option) => option.emailId === newValue);
                  setState((draft) => {
                    draft.email = newValue;
                    draft.firstName = selectedUser?.firstName || "";
                    draft.lastName = selectedUser?.lastName || "";
                    draft.mobileNumber = selectedUser?.mobileNo;
                  });
                }}
                onInputChange={(event, newInputValue) => {
                  handleEmailChange(newInputValue);
                  setState((draft) => {
                    draft.email = newInputValue;
                  });
                }}
                renderInput={(params) => <TextField {...params} label="Email" />}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                size="small"
                sx={{ minWidth: 250, maxWidth: 250 }}
                onChange={(e) => {
                  setState((draft) => {
                    draft.firstName = e.target.value;
                  });
                }}
                required
                error={state.firstNameError}
                value={state.firstName}
                label={"First Name"}
                disabled
                helperText={state.firstNameErrorText}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                size="small"
                sx={{ minWidth: 250, maxWidth: 250 }}
                onChange={(e) => {
                  setState((draft) => {
                    draft.lastName = e.target.value;
                  });
                }}
                required
                disabled
                error={state.lastNameError}
                value={state.lastName}
                label={"Last Name"}
                helperText={state.lastNameErrorText}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                size="small"
                sx={{ minWidth: 250, maxWidth: 250 }}
                value={state.mobileNumber}
                error={state.mobileNumberError}
                label="Mobile Number"
                disabled
                onChange={handleInputChange}
                required
              // placeholder=" number"
              />
            </Grid>
            {/* <Grid item xs={6}>
              <FormControl size="small" sx={{ minWidth: 250, maxWidth: 250 }}>
                <InputLabel id="standard-label">Delegate Role</InputLabel>
                <Select
                  labelId="select-standard-label"
                  id="select-standard"
                  value={state.delegateRole}
                  error={state.delegateRoleError}
                  onChange={(e) => {
                    setState((previousState) => {
                      previousState.delegateRole = e?.target?.value;
                    });
                  }}
                  label="Designantion"
                >
                {state.userRoleList?.map((value, index) => (
                    <MenuItem key={value + index} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}
            <Grid item xs={6}>
              <Autocomplete
                size="small"
                disableCloseOnSelect
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{ minWidth: 250, maxWidth: 250 }}
                multiple
                options={getSystems()}
                value={state.systems || []}
                onChange={(_, newValue) => {
                  setState((draft) => {
                    if (newValue.find((option) => option.id === "select-all")) {
                      draft.systems = system_options;
                    } else if (newValue.find((option) => option.id === "unselect-all")) {
                      draft.systems = [];
                    } else {
                      draft.systems = newValue;
                    }
                  });
                }}
                renderTags={(value, getTagProps) => {
                  return (
                    <div>
                      <Chip size="small" variant="outlined" label={value[0].label} {...getTagProps({ index: 0 })} />
                      {value.length > 1 && (
                        <AutocompleteStationListPop title={value.map((stn) => stn?.label ?? "").toString()}>
                          <Chip size="small" label={`+${value.length - 1}`} />
                        </AutocompleteStationListPop>
                      )}
                    </div>
                  );
                }}
                renderInput={(params) => <TextField {...params} label="Systems" error={!!state.systemsErrorText} helperText={state.systemsErrorText} />}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl size="small" sx={{ minWidth: 250, maxWidth: 250 }}>
                <InputLabel id="standard-label">Service Type</InputLabel>
                <Select
                  labelId="select-standard-label"
                  id="select-standard"
                  value={state.serviceType}
                  required
                  onChange={(e) => {
                    setState((previousState) => {
                      previousState.serviceType = e?.target?.value;
                      previousState.authority = "";
                    });
                  }}
                  label="User Role"
                >
                  {["Gazetted", "Non-Gazetted"]?.map((value, index) => (
                    <MenuItem key={value + index} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl size="small" sx={{ minWidth: 250, maxWidth: 250 }}>
                <InputLabel id="standard-label">User Role</InputLabel>
                <Select
                  labelId="select-standard-label"
                  id="select-standard"
                  value={state.authority}
                  required
                  error={state.zoneCodeError}
                  onChange={(e) => {
                    setState((previousState) => {
                      previousState.authority = e?.target?.value;
                    });
                  }}
                  label="User Role"
                >
                  {state.userRoleList?.map((value, index) => (
                    <MenuItem key={value + index} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl size="small" sx={{ minWidth: 250, maxWidth: 250 }}>
                <InputLabel id="standard-label">Zone Code</InputLabel>
                <Select
                  multiple
                  labelId="select-standard-label"
                  id="select-standard"
                  value={state.zoneCode}
                  required
                  // disabled
                  error={state.zoneCodeError}
                  onChange={(e) => {
                    setState((previousState) => {
                      previousState.zoneCode = e?.target?.value;
                    });
                  }}
                  label="Zone Code"
                >
                  {state.zoneList?.map((zone, index) => (
                    <MenuItem key={zone + index} value={zone}>
                      {zone}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl size="small" sx={{ minWidth: 250, maxWidth: 250 }}>
                <InputLabel id="standard-label">Division Code</InputLabel>
                <Select
                  multiple
                  labelId="select-standard-label"
                  id="select-standard"
                  value={state.divisionCode}
                  required
                  error={state.divisionCodeError}
                  onChange={(event) => {
                    setState((draft) => {
                      draft.divisionCode = event?.target?.value;
                    });
                  }}
                  // disabled
                  label="Division Code"
                >
                  {state.divisionList?.map((division, index) => (
                    <MenuItem key={division + index} value={division}>
                      {division}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl size="small" sx={{ minWidth: 250, maxWidth: 250 }}>
                <InputLabel id="standard-label">Station Code</InputLabel>
                <Select
                  multiple
                  labelId="select-standard-label"
                  id="select-standard"
                  value={state.stationCode}
                  required
                  error={state.stationCodeError}
                  onChange={(event) => {
                    setState((state) => {
                      state.stationCode = event?.target?.value;
                    });
                  }}
                  label="Station Code"
                >
                  {state.stationList.length > 0 && (
                    <MenuItem>
                      <ListItemText
                        primary={state.stationCode.length === state.stationList.length ? "Deselect All" : "Select All"}
                        onClick={(event) => {
                          event.stopPropagation();
                          const _stationList =
                            state.stationCode.length === state.stationList.length ? [] : state.stationList;
                          setState((state) => {
                            state.stationCode = _stationList;
                          });
                        }}
                      ></ListItemText>
                    </MenuItem>
                  )}
                  {state.stationList.map((station, index) => (
                    <MenuItem key={station + index} value={station}>
                      {station}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {!editRow && (
              <>
                <Grid item xs={6}>
                  <TextField
                    size="small"
                    sx={{ minWidth: 250, maxWidth: 250 }}
                    onChange={(event) => {
                      setState((previousState) => {
                        previousState.password = event.target.value;
                      });
                    }}
                    inputProps={{
                      type: "password",
                    }}
                    required
                    error={state.passwordError}
                    value={state.password}
                    label={"Password"}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    size="small"
                    sx={{ minWidth: 250, maxWidth: 250 }}
                    onChange={(event) => {
                      setState((previousState) => {
                        previousState.confirmPassword = event.target.value;
                      });
                    }}
                    inputProps={{
                      type: "password",
                    }}
                    required
                    error={state.confirmPasswordError}
                    helperText={state.confirmPasswordError}
                    value={state.confirmPassword}
                    label={"Confirm Password"}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(pcdoUserForm?.isPcdoUser)}
                    onChange={(event) => {
                      handlePcdoFormChange("isPcdoUser", event.target.checked);
                    }}
                  />
                }
                label="Pcdo user"
              />
            </Grid>
            {pcdoUserForm?.isPcdoUser && (
              <>
                <Grid item xs={6}>
                  <Autocomplete
                    options={pcdoUserRoleOptions}
                    size="small"
                    value={pcdoUserRoleOptions.find((obj) => obj.id === pcdoUserForm.role_id) ?? null}
                    onChange={(event, newValue) => {
                      handlePcdoFormChange("role_id", newValue?.id ?? null);
                    }}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        label="PCDO user role"
                        required
                        error={pcdoUserFormValidation.role_id}
                        helperText={pcdoUserFormValidation.role_id}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    options={deriveUserGroupOptions()}
                    size="small"
                    value={deriveUserGroupOptions().find((obj) => obj.id === pcdoUserForm.group_id) ?? null}
                    onChange={(event, newValue) => {
                      handlePcdoFormChange("group_id", newValue?.id ?? null);
                    }}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        label="PCDO user group"
                        required
                        error={pcdoUserFormValidation.group_id}
                        helperText={pcdoUserFormValidation.group_id}
                      />
                    )}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" autoFocus onClick={onClear}>
            Clear
          </Button>
          <Button variant="contained" autoFocus onClick={onSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddUser;
